import React, { Component } from "react";
import Footer from "../../components/footer.component";
import Header from "../../components/header.component";
import "../../css/page.css";
import reportVisitService from "../../reporting-visit/report-visit.service";

export default class PricacyPolicyPage extends Component {
  componentDidMount() {
    document.title =
      "Privacy policy | David Šimák - A self-taught JAVA/Kotlin developer";
    window.scrollTo(0, 0);
    reportVisitService.report(window.location.pathname, document.title);
  }
  render() {
    return (
      <div>
        <Header lightColor={true} />
        <div className="page_title_container">
          <label class="big_title">Privacy policy</label>
        </div>

        <div class="section">
          <p>
            This Privacy Policy provides policies and procedures for collecting,
            using, and disclosing your information. Users access the services
            created by <b>me (David Šimák) “Services”</b> through the
            applications, APIs and third-parties. A <b>“Device”</b> is any
            computer used to access the <b>Services</b>, including without
            limitation a desktop, laptop, mobile phone, tablet or other consumer
            electronic device. This <b>Privacy Policy</b> governs your access of
            the <b>Services</b>, regardless of how you access it, and by using
            my <b>Services</b> you consent to the collection, transfer,
            processing, storage, disclosure and other uses described in this{" "}
            <b>Privacy Policy</b>. All of the different forms of data, content,
            and information described below are collectively referred to as{" "}
            <b>“Information”</b>.
          </p>

          <br />
          <h1 className="section-title">
            Data collection, processing and storing
          </h1>
          <hr className="section-title-hr" />

          <p>
            <b>
              I may collect and store the following information when running the{" "}
              <b>Services</b>:
            </b>
          </p>

          <br />
          <h2>Information You Provide</h2>

          <p>
            When you register for an account, I collect some{" "}
            <b>Personal Information</b>, such as your email address, user name,
            Name and Surname. You may also provide me with your contact's email
            addresses when sharing your data with them. I may also receive{" "}
            <b>Personal Information</b> (for example, your email address)
            through other users, for example if they have tried to share
            something with you.
          </p>
          <br />
          <h2>Your Data</h2>

          <p>
            I collect and store data you upload, download, or access with the{" "}
            <b>Services (“Data”)</b>.
          </p>

          <br />
          <h2>System logs, log data and maintenance</h2>

          <p>
            For operation and maintenance purposes, this <b>Services</b> and any
            third-party services may collect files that record interaction with
            this <b>Service</b> logs use other <b>Personal Data</b> for this
            purpose. When you use the <b>Service</b>, I automatically record
            information from your <b>Device</b>, its software, and your activity
            using the <b>Service</b>. This may include the information you
            search for through the Service, locale preferences, identification
            numbers associated with your Devices, date and time stamps, system
            configuration information, and other interactions with the{" "}
            <b>Service</b>.
          </p>

          <br />
          <h2>Cookies</h2>

          <p>
            I use <b>“persistent cookies”</b> to save your registration ID and
            login password for future logins to the Service. I use “session ID
            cookies” to enable certain features of the Service, to better
            understand how you interact with the Services and to monitor
            aggregate usage and web traffic routing on the Services. You can
            instruct your browser, by changing its options, to stop accepting
            cookies or to prompt you before accepting a cookie from the websites
            you visit. If you do not accept cookies, however, you may not be
            able to use all aspects of the Services.
          </p>
          <br />
          <h1 className="section-title">
            How I use you Personal Information and why
          </h1>
          <hr className="section-title-hr" />
          <br />
          <h2>Personal Information</h2>

          <p>
            In the course of using the <b>Services</b>, I may collect personal
            information that can be used to contact or identify you{" "}
            <b>(“Personal Information”)</b>. Personal Information is or may be
            used: <br />
            <ol>
              <li>to provide and improve my Services</li>
              <li>to administer your use of the Services</li>
              <li>to better understand your needs and interests</li>
              <li>to personalize and improve your experience</li>
            </ol>
          </p>

          <br />
          <h2>Geo-Location Information</h2>

          <p>
            Some Devices allow applications to access real-time location-based
            information (for example, GPS). My <b>Services does not</b> collect
            such information from you at any time while you download or use my{" "}
            <b>Services</b> as of the date this policy went into effect, but may
            do so in the future with your consent to improve my Services.
          </p>

          <br />
          <h2>Your Data</h2>

          <p>
            You have control over who sees the Data you uploaded, downloaded or
            access with the <b>Services</b>. I cannot view it unless you
            expressly give me permission or it’s necessary to comply with my
            legal obligations. Specifically: To help refine or improve the
            technology, I may ask you for permission to review portions of your
            Data. Also if you contact me for help with specific pieces of Data
            in your account, I may ask for your temporary permission to look at
            your Data. This permission terminates when the issue is resolve.
            <br />
            <br />
            Whether I need to process your personal information either to comply
            with law, or to perform the terms of a contract I have with you and
            you fail to provide that information when requested, I may not be
            able to perform the contract I have or am trying to enter into with
            you (for example, to provide you with the functionalities of the
            Services). In this case, I may have to stop you using my{" "}
            <b>Services</b>.
          </p>
          <br />
          <h1 className="section-title">Information Sharing and Disclosure</h1>
          <hr className="section-title-hr" />
          <br />
          <h2>Use</h2>

          <p>
            I do not sell your <b>Personal Information</b> to third parties. I
            may share or disclose your information with your consent, for
            example if you use a third party application to access your account.
          </p>
          <br />
          <h2>Service Providers, Business Partners and Others</h2>

          <p>
            I use certain trusted third party companies and individuals to help
            me provide, analyze, and improve the <b>Services</b> (including but
            not limited to data storage, maintenance services, database
            management, analytics, and improvement of the <b>Services</b>’s
            features). These third parties may have access to your information
            only for purposes of performing these tasks on my behalf and under
            obligations similar to those in this Privacy Policy. You can view
            the third parties I use to help me provide my Services in Appendix
            1.
          </p>
          <br />
          <h2>
            Compliance with Laws and Law Enforcement Requests; Protection of my
            Rights
          </h2>

          <p>
            I may disclose to parties outside me and information about you that
            I collect when I have a good faith belief that disclosure is
            reasonably necessary to
            <br />
            <ol>
              <li>comply with a law, regulation or compulsory legal request</li>
              <li>
                protect the safety of any person from death or serious bodily
                injury
              </li>
              <li>prevent fraud or abuse of my Services or its users</li>
              <li>to protect my property rights</li>
            </ol>
          </p>

          <br />
          <h2>Business Transfers</h2>

          <p>
            If I am involved in a merger, acquisition, or sale of all or a
            portion of my assets, your information may be transferred as part of
            that transaction, but I will notify you (for example, via email
            and/or a prominent notice on my website) of any change in control or
            use of your <b>Personal Information</b> or <b>Data</b>, or if either
            become subject to a different <b>Privacy Policy</b>. I will also
            notify you of choices you may have regarding the information.
          </p>

          <br />
          <h2>Non-Private or Non-Personal Information</h2>

          <p>
            I may disclose your non-private, aggregated, or otherwise
            non-personal information, such as usage statistics of my Services.
          </p>
          <br />
          <h2>Your Rights Relating To Your Information</h2>

          <p>
            You can contact me at{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="mailto://support@davidsimak.dev"
            >
              support@davidsimak.dev
            </a>{" "}
            to ask me to provide access to, correct, update, or delete your
            personal information. Some of this actions can be done at{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://account.davidsimak.dev/"
            >
              https://account.davidsimak.dev/
            </a>
            . I may ask you for proof of account ownership and/or identity
            before fulfilling your request. This is a security measure to ensure
            that your information is not disclosed to any person who has no
            right to receive it. In some cases I may retain copies of your
            information if required by law. Please note that some or all of your
            personal information may be required in order for me to provide you
            with access to the certain specific functionalities of my{" "}
            <b>Services</b>.
          </p>
          <br />
          <h2>How Long I Store Your Information</h2>

          <p>
            I will retain your information for as long as your account is active
            or as needed to provide you services. I may retain and use your
            information as necessary to comply with my legal obligations,
            resolve disputes, and enforce my agreements. Consistent with these
            requirements, I will try to delete your information quickly upon
            request. Please note, however, that there might be latency in
            deleting information from my servers and backed-up versions might
            exist after deletion. In addition, I do not delete from my servers
            files that you have in common with other users.
          </p>

          <br />
          <h2>Where I Store Your Information</h2>

          <p>
            If you register for an account and sync your device with my
            Services, your Information (including but not limited your Data),
            will be stored on servers hosted by <b>Forpsi in Czech Republic</b>.
            For information regarding{" "}
            <b>Forpsi Data Processing and Security Terms</b>, please visit{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.forpsi.com/"
            >
              https://www.forpsi.com
            </a>
            .
          </p>
          <br />
          <h2>Security</h2>

          <p>
            The security of your information is important to me. I follow
            generally accepted standards to protect the information submitted to
            me, both during transmission and once I receive it. No method of
            electronic transmission or storage is 100% secure, however.
            Therefore, I cannot guarantee its absolute security.
          </p>
          <br />

          <h1 className="section-title">A Note for European Users</h1>
          <hr className="section-title-hr" />

          <p>
            You have the right under this <b>Privacy Policy</b> and by the{" "}
            <b>
              General Data Protection Regulation (Regulation EU 2016/679) (also
              known as GDPR)
            </b>{" "}
            if you are within the EU, to:
            <br />
            <br />
            <h2>Request access to your personal information</h2>
            This enables you to receive a copy of the information I hold about
            you and to check that I am lawfully processing it.
            <br />
            <br />
            <h2>
              Request correction of the personal information that I hold about
              you
            </h2>
            This enables you to have any incomplete or inaccurate information I
            hold about you corrected.
            <br />
            <br />
            <h2>Request erasure of your personal information</h2>
            This enables you to ask us to delete or remove information where
            there is no good reason for us continuing to process it.
            <br />
            <br />
            <h2>Object to processing of your personal information</h2>
            This right exists where I am relying on a legitimate interest as the
            legal basis for my processing and there is something about your
            particular situation, which makes you want to object to processing
            of your information on this ground. You also have the right to
            object where I am processing your information for direct marketing
            purposes.
            <br />
            <br />
            <h2>
              Request the restriction of processing of your personal information
            </h2>
            This enables you to ask us to suspend the processing of your
            information, for example if you want us to establish its accuracy or
            the reason for processing it.
            <br />
            <br />
            <h2>Request the transfer of your personal information</h2>
            I will provide to you your personal information in a structured,
            commonly used, machine-readable format. Note that this right only
            applies to automated information which you initially provided
            consent for us to use or where I used the information to perform a
            contract with you.
            <br />
            <br />
            <h2>Withdraw consent</h2>
            This right only exists where I am relying on consent to process your
            information (“Consent Withdrawal”). If you withdraw your consent, I
            may not be able to provide you with access to the certain specific
            functionalities of my Services. I will advise you if this is the
            case at the time you withdraw your consent.
            <br />
            <br />
            <br />
            <br />
            If you want to exercise any of the rights described above or submit
            a complaint regarding this Privacy Policy, please send an email to{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="mailto://support@davidsimak.dev"
            >
              support@davidsimak.dev
            </a>{" "}
            with “GDPR Request” in the subject line. In the email please
            describe, with specificity, the GDPR right you are requesting
            assistance with. If you feel that your complaint has not been
            adequately resolved, please note that the GDPR gives you the right
            to contact your local data protection supervisory authority.
          </p>

          <br />

          <h1 className="section-title">My Policy Toward Children</h1>
          <hr className="section-title-hr" />

          <p>
            My Services is not directed to persons under 13. I do not knowingly
            collect personally identifiable information from children under 13.
            If a parent or guardian becomes aware that his or her child has
            provided me with Personal Information without their consent, he or
            she should contact me at{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="mailto://support@davidsimak.dev"
            >
              support@davidsimak.dev
            </a>
            . If I become aware that a child under 13 has provided me with
            Personal Information, I will take steps to delete such information
            from my files.
          </p>

          <br />

          <h1 className="section-title">Changes to my Privacy Policy</h1>
          <hr className="section-title-hr" />

          <p>
            This <b>Privacy Policy</b> may change from time to time, so please
            check back from time to time. If I make a change to this privacy
            policy that I believe materially reduces your rights, I will provide
            you with notice (for example, by email). By continuing to use the
            Services after those changes become effective, you agree to be bound
            by the revised Privacy Policy.
          </p>

          <br />

          <h1 className="section-title">Contact Me</h1>
          <hr className="section-title-hr" />

          <p>
            I welcomes your comments regarding this <b>Privacy Policy</b>.
            Please contact me by email at{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="mailto://support@davidsimak.dev"
            >
              support@davidsimak.dev
            </a>
          </p>

          <br />
          <h1 className="section-title">
            Appendix 1. Third party service provider
          </h1>
          <hr className="section-title-hr" />

          <p>
            Forpsi - Cloud Infrastructure -{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.forpsi.com/"
            >
              https://forpsi.com/
            </a>
          </p>
        </div>

        <Footer />
      </div>
    );
  }
}
